/**
 * Basename for a catalog map file (`maps/<name>.json`).
 * Shared by the editor and the DEV write hook so a bad name cannot leave `maps/`.
 */
export function sanitizeMapFilename(raw: string): string | null {
  const base = raw.trim().replace(/^.*[/\\]/, '');
  const stem = base.replace(/\.json$/i, '');

  if (!/^[A-Za-z0-9][A-Za-z0-9._-]{0,127}$/.test(stem)) {
    return null;
  }

  return `${stem}.json`;
}

export function isSafeMapFilename(name: string): boolean {
  return sanitizeMapFilename(name) === name;
}
